// extracted by css-extract-rspack-plugin
export default {"conversationCheckboxFilters":"conversationCheckboxFilters-AIEL7V","groupLabel":"groupLabel-pubjm7"};